module.exports = __webpack_public_path__ + "static/media/icon-off-side.98536452.svg";